function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function isObject(o) {
    return (typeof o === "undefined" ? "undefined" : _type_of(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function extend(target, src) {
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter(function(key) {
        return noExtend.indexOf(key) < 0;
    }).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
            if (src[key].__swiper__) target[key] = src[key];
            else extend(target[key], src[key]);
        } else {
            target[key] = src[key];
        }
    });
}
function needsNavigation() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses() {
    var classNames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    var classes = classNames.split(' ').map(function(c) {
        return c.trim();
    }).filter(function(c) {
        return !!c;
    });
    var unique = [];
    classes.forEach(function(c) {
        if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(' ');
}
export { isObject, extend, needsNavigation, needsPagination, needsScrollbar, uniqueClasses };
